export const heartShapeVertices = [
  -0.000014625, 0.0010057500000000001, 0.0, 0.0, 0.0, -1.0, -0.001281375,
  0.001737, 0.0, 0.0, 0.0, -1.0, -0.00204075, 0.0012982500000000001, 0.0, 0.0,
  0.0, -1.0, -0.00204075, -0.000682875, 0.0, 0.0, 0.0, -1.0, -0.000014625,
  -0.00186075, 0.0, 0.0, 0.0, -1.0, 0.002012625, -0.000682875, 0.0, 0.0, 0.0,
  -1.0, 0.002012625, 0.0012982500000000001, 0.0, 0.0, 0.0, -1.0, 0.00125325,
  0.001737, 0.0, 0.0, 0.0, -1.0,
];

export const heartShapeIndicies = [
  6, 0, 7, 0, 2, 1, 5, 0, 6, 0, 3, 2, 5, 3, 0, 4, 3, 5,
];
